module.exports = __webpack_public_path__ + "static/media/drag_tab.f75db2d1.gif";